import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './HtmlWithPinyinContent.module.less';

export const HtmlWithPinyinContent = ({ html, className }) => {
  return (
    <div
      className={classNames(styles.htmlWithPinyinContainer, className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

HtmlWithPinyinContent.propTypes = {
  html: PropTypes.string.isRequired,
  className: PropTypes.string,
};
